import React from "react"
import { Link } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import NewWindowIconGrayImage from "assets/images/NewWindowiconGray.svg"

const useStyles = makeStyles(theme => ({
  newWindowIcon: {
    width: "16px",
    height: "16px",
    verticalAlign: "middle",
    marginLeft: "3px",
  },
}))

const TextLink = props => {
  const classes = useStyles()

  return (
    <Link
      href={props.link}
      id={props.id}
      target={props.target}
      rel="noopener noreferrer"
      data-ga={props.dataGa}
      data-testid={props.dataTestid}
    >
      {props.children}
      <img
        src={NewWindowIconGrayImage}
        alt="newWindowIcon"
        className={classes.newWindowIcon}
      />
    </Link>
  )
}

export default TextLink
